import { render, staticRenderFns } from "./event-registration-config.vue?vue&type=template&id=50b7ebb2"
import script from "./event-registration-config.vue?vue&type=script&lang=ts"
export * from "./event-registration-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports